import { createSelector } from 'reselect'

const getInteractiveVideoSessionType = state => state.interactiveVideo.sessionType

export default createSelector(
	getInteractiveVideoSessionType,
	interactiveVideoSessionType => interactiveVideoSessionType
)
